import { useTranslation } from "react-i18next";
import PageLayout from "../../../Layouts/PageLayout/PageLayout";
import "./InformePlaceholder.scss";

const InformePlaceholder = ({ title }) => {
    const { t } = useTranslation();

    return (
        <PageLayout
            title={title}
            subtitle={t("common.noResults", "No se encontraron resultados")}
        >
            <div className="informe-placeholder">
                {t("informes.placeholder", "Informe en preparación")}
            </div>
        </PageLayout>
    );
};

export default InformePlaceholder;
